import { apiClient } from './client';
import type { ApiResponse, Tenant, LifecycleEvent, TenantMetrics, TenantStatus } from './types';

// P2 console-api 的 list/detail 把合同字段映射成 camelCase（与 snake_case 的 DbContract 不同）。
// list 接口返回的 currentContract 是精简版（8 字段），详情接口的 currentContract / historyContracts
// 是完整版（含 isCurrent/notes/createdAt）。
export interface CurrentContractView {
  id: number;
  contractNo: string | null;
  planCode: string | null;
  startAt: string;
  endAt: string;
  graceDays: number;
  suspendDays: number;
  purgeDays: number;
}

export interface TenantContractDetail extends CurrentContractView {
  isCurrent: boolean;
  notes: string | null;
  createdAt: string;
}

export interface TenantListItem extends Tenant {
  currentContract: CurrentContractView | null;
}

export async function listTenants(params: { status?: TenantStatus; search?: string } = {}) {
  const r = await apiClient.get<ApiResponse<{ items: TenantListItem[] }>>('/tenants', { params });
  return r.data.data!.items;
}

export interface CreateTenantInput {
  code: string;
  displayName: string;
  plan: string;
  contractStartAt: string;
  contractEndAt: string;
  graceDays?: number;
  suspendDays?: number;
  purgeDays?: number;
  contractNo?: string | null;
  notes?: string | null;
  adminPassword: string;
  adminEmail: string;
  adminPhone: string;
}

export async function createTenant(body: CreateTenantInput) {
  const r = await apiClient.post<ApiResponse<{ tenantId: number; provisionJobId: number }>>('/tenants', body);
  return r.data.data!;
}

// P2 tenant-detail.ts 返回 currentContract / historyContracts 是完整 camelCase view（含 isCurrent/notes/createdAt）
export interface TenantDetail {
  tenant: Tenant;
  currentContract: TenantContractDetail | null;
  historyContracts: TenantContractDetail[];
  recentEvents: LifecycleEvent[];
  metrics: TenantMetrics | null;
}

export async function getTenantDetail(id: number) {
  const r = await apiClient.get<ApiResponse<TenantDetail>>(`/tenants/${id}`);
  return r.data.data!;
}
